/** 権限 */
export const ROLE = {
  // 権限なし
  NONE: null,
  // 経営者権限
  EXECUTIVE: 1,
  // マネージャー権限
  MANAGER: 2,
  // 一般権限
  GENERAL: 3,
  // 社外パートナー権限
  OUTSIDE_PARTNER: 4
};

/** 通貨単位 */
export const CURRENCY_UNITS = {
  // カンマ区切り
  COMMA: 1,
  // 千円単位
  THOUSAND_YEN: 2,
  // 万円単位
  TEN_THOUSAND_YEN: 3,
  // 百万円単位
  MILLION_YEN: 4
};

/** 通貨単位のラベル */
export const CURRENCY_UNIT_LABELS: { [key: number]: string } = {
  [CURRENCY_UNITS.COMMA]: 'カンマ区切り',
  [CURRENCY_UNITS.THOUSAND_YEN]: '千円単位',
  [CURRENCY_UNITS.TEN_THOUSAND_YEN]: '万円単位',
  [CURRENCY_UNITS.MILLION_YEN]: '百万円単位'
};

/** 担当 */
export const ASSIGNEE_ROLE = {
  // 営業担当
  SALES: 1,
  // 現場担当
  SITE: 2,
  // 設計担当
  ACCOUNTANT: 3,
  // 積算担当
  PLAN: 4,
  // 社外パートナー
  OUTSIDE_PARTNER: 5
};

/** 社員タイプ */
export const EMPLOYEE_TYPE = {
  // 自社社員
  INSIDE_EMPLOYEE: 1,
  // 社外パートナー
  OUTSIDE_PARTNER: 2
};

/** プラン */
export const PLAN = {
  NONE: null,
  // 企業
  ENTERPRISE: 1,
  // 標準
  STANDARD: 2,
  // エントリー
  ENTRY: 3,
  // クラウドストレージ
  CLOUD_STORAGE: 4
};

/** 消費税の端数計算ルール */
export const TAX_RULE = {
  NONE: null,
  // 切り捨て
  FLOOR: 1,
  // 切り上げ
  CEIL: 2,
  // 四捨五入
  ROUND: 3
};

/** 見積書・第一階層の最大項目数 */
export const ESTIMATE_ITEM_MAX = 120;
/** 見積書・第二階層以降の最大項目数 */
export const ESTIMATE_SUB_ITEM_MAX = 72;
/** 見積書PDFの1ページに表示できる項目数 */
export const ESTIMATE_ITEM_MAX_PER_PDF_PAGE = 24;
/** 見積書・全体の最大項目数 */
export const ESTIMATE_TOTAL_ITEM_MAX = 1200;
/** 見積書・全体モードの推奨項目数 */
export const ESTIMATE_ALLVIEW_MODE_ITEM_MAX = 100;
/** 見積書・デフォルトで表示する項目数 */
export const ESTIMATE_DEFAULT_ITEM_COUNT = 24;
/** 商品発注書の項目の最大件数 */
export const MERCHANDISE_ORDERS_ITEM_MAX = 67;
/** 外注発注書の最大件数 */
export const OUTSOURCE_ORDERS_ITEM_MAX = 18;
/** 現場連絡表の最大件数 */
export const SITE_CONTACTS_ITEM_MAX = 55;

/** ローカルストレージ保存時間(h) */
export const LOCAL_STORAGE_SAVE_TIME = 24;
/** ローカルストレージの見積書用のキー名 */
export const LOCAL_STORAGE_ESTIMATE_KEY = 'estimate_';
/** ローカルストレージの見積書用のキー名 */
export const ESTIMATE_OPERATION_USER_KEY = ' estimate_user_';
/** ローカルストレージの請求書用のキー名 */
export const INVOICE_OPERATION_USER_KEY = ' invoice_user_';
/** ローカルストレージの見積書用のキー名(新規) */
export const LOCAL_STORAGE_NEW_ESTIMATE_KEY = 'estimate_construction_id_';
/** ローカルストレージの実行予算書用のキー名 */
export const LOCAL_WORKING_BUDGET_KEY = 'working_budget_';
/** ローカルストレージの実行予算書用のキー名(新規) */
export const LOCAL_STORAGE_NEW_WORKING_BUDGET_KEY = 'working_budget_id_';
/** ローカルストレージの社内メモ表示用のキー名 */
export const SHOW_AUTHOR_MEMO_USER_KEY = 'show_author_memo_user_';

/** メールバリデーションの正規表現 */
export const emailValidation =
  /^[a-zA-Z0-9_.+-]+@[a-zA-Z0-9-]+\.[a-zA-Z0-9-.]+$/;

/** FAQへのリンク */
export const faqLink: { [Key: string]: string } = {
  // トップページ
  top: 'https://phrygian-maxilla-3b4.notion.site/FAQ-CONOC-d4c3686ef977458ab17dc0a8fb3abb76',
  // 二段階認証
  mfa: 'https://phrygian-maxilla-3b4.notion.site/8c168d01af714c9fb80e919ef8d35f32',
  // 二段階認証メールについて
  mfa_mail:
    'https://phrygian-maxilla-3b4.notion.site/0d03eee1c914405292f991d70705df93',
  // ファイル共有機能
  url_share:
    'https://phrygian-maxilla-3b4.notion.site/3c59dd5d00ea49ec9370e572983b8c61',
  // 共有リンク作成
  create_url:
    'https://phrygian-maxilla-3b4.notion.site/5d7899b1e45c49438fef1613c396ddf4',
  // 共有機能のアップロード権限について
  uploadable:
    'https://phrygian-maxilla-3b4.notion.site/48dc1e85db484e4a9907e44af4ac8ae1',
  // 共有ゲスト側
  share_guest:
    'https://phrygian-maxilla-3b4.notion.site/aa6bebb6dd2b48c2bda457960a009c34',
  // 利用規約
  terms_of_service:
    'https://phrygian-maxilla-3b4.notion.site/bb58d31fa1ca49b395adc5a5a8991aa8',
  // リリースノート
  release_note:
    'https://phrygian-maxilla-3b4.notion.site/CONOC-bccaa54076e14ca29436f690a509ae76',
  // 社員マスタの権限設定
  permission_settings:
    'https://phrygian-maxilla-3b4.notion.site/eeb05279c14a4c7a8fdf9573f606c656',
  // 現場管理、カレンダーURL
  calendar_url:
    'https://phrygian-maxilla-3b4.notion.site/Google-be126019f95c44e79e6b28eb023f14d3',
  // 情報管理機能（箱機能）のCSVエクスポート
  construct_ext_info_box:
    'https://phrygian-maxilla-3b4.notion.site/CSV-fdaf43b3bd0e47c6afa9b77a09c4be65'
};

export const DOCUMENT_TYPE = {
  // 見積書
  ESTIMATE: 1,
  // 請求書
  INVOICE: 2,
  // 契約書
  CONTRACT: 3,
  // 商品発注書
  MERCHANDISE_ORDER: 4,
  // 外注発注書
  OUTSOURCE_ORDER: 5,
  // 現場連絡表
  SITE_CONTACT: 8,
  // 領収書
  RECEIPT: 9
};

export const BILLING_TYPE = {
  // 着手金
  DEPOSIT: 1,
  // 中間金
  INTERIM_PAYMENT: 2,
  // 残金
  REMAINING_PAYMENT: 3,
  // 一括
  ONE_TIME_PAYMENT: 4,
  // 契約金
  CONTRACT_PAYMENT: 5
};

export const RECEIPT_ISSUE_STATUS = {
  // 発行済
  ISSUED: 1
};

// 工程のステータス管理
export const SITE_PROCESS_STATUS_NOT_STARTED = 1; // 未着手
export const SITE_PROCESS_STATUS_IN_PROGRESS = 2; // 進行中
export const SITE_PROCESS_STATUS_COMPLETED = 3; // 完了
export const SITE_PROCESS_STATUS_UNNECESSARY = 4; // 実施不要};

// 工程ステータスを配列で保持
export const SITE_PROCESS_STATUSES = [
  SITE_PROCESS_STATUS_NOT_STARTED,
  SITE_PROCESS_STATUS_IN_PROGRESS,
  SITE_PROCESS_STATUS_COMPLETED,
  SITE_PROCESS_STATUS_UNNECESSARY
];

// ページング
export const HISTORY_DISPLAY_LIMIT = 10; // 1ページあたりの表示件数

// ページング
export const SITE_TASK_DISPLAY_LIMIT = 10; // 1ページあたりの表示件数

// 履歴の変更内容
export const HISTORY_ADDED_DIVISION_CREATED = 1; // 新規作成
export const HISTORY_ADDED_DIVISION_UPDATED = 2; // 更新
export const HISTORY_ADDED_DIVISION_DELETED = 3; // 削除

// タスク更新履歴のorder
export const ORDER_CATEGORY_OUTSOURCING = 1; // 外注
export const ORDER_CATEGORY_PRODUCT = 2; // 商品

// データがない時のデフォルトメッセージ
export const DEFAULT_MESSAGE_NO_DATA = 'データがありません';

export const DEFAULT_MESSAGE_UNEXPECTED_ERROR = '予期せぬエラーが発生しました';

export const DEFAULT_MESSAGE_INVALID_URL = 'URLの形式が正しくありません';

// 工程表・タスク管理画面にアクセス可能なtenant.site_mange_plan_idの値
export const SITE_MANGE_PLAN_ACCESS_ALLOW = 1;

export const COLOR_LIGHT_GRAY = '#808080';

export const COLOR_WHITE = '#FFFFFF';

export const DELIVERY_SITE = {
  // 現場
  SITE: 1,
  // 事務所
  OFFICE: 2,
  // その他
  OTHER: 3
};

// カスタム書類タイプ（m_custom_formats_tableのformat_type_idを検索するための数字）
export const FORMAT_TYPE_ID = {
  ESTIMATE: 1
  // 以下、追加例
  // INVOICE: 2, // 請求書
  // MERCHANDISE: 3, // 商品発注書
  // OUTSOURCE: 4, // 外注発注書
  // SITE_CONTACT: 5, // 現場連絡票
};

export const SITE_CONTACT_ITEM_PER_PAGE = {
  // 1ページ目
  FIRST_PAGE: 17,
  // 2ページ目以降
  SECOND_PAGE_AND_AFTER: 38
};

export const END_WORDS = [
  '）',
  ')',
  ']',
  '}',
  '】',
  '」',
  '。',
  '>',
  '＞',
  '.'
];

export const NOT_LOGGED_IN: string = 'Not logged in!';

// 見積書の御見積条件欄の色をグレーにする企業(2024/01/26: 株式会社日設のみ)
export const ESTIMATE_COLOR_GRAY_TENANT_IDS: { [key: string]: number[] } = {
  local: [],
  dev: [],
  stg: [66], // 66 日設テスト用アカウント
  prd: [462, 595, 631] // 462:日設  595:株式会社トップフロンティア  631:EMソリューションズ株式会社
};

// 顧客画面に顧客別請求書新規作成ボタンを表示する企業
export const CUSTOMER_SPECIFIC_INVOICE_AVAILABLE_TENANT_IDS: {
  [key: string]: number[];
} = {
  local: [1],
  dev: [],
  stg: [3], // 3:CONOC
  prd: [
    3, // 3:株式会社CONOC
    8, // 8:株式会社NO-SCALE
    242, // 242:インドアヒズ株式会社
    396, // 396:株式会社プロスパー
    477, // 477:ライズシード株式会社
    544, // 544:株式会社yuu’z
    295, // 295:株式会社丸紘
    51, // 51:Aonosumika合同会社
    527, // 527:愛.すまいる
    425, // 425:(株)ヒットデザインワークス
    571, // 571:株式会社イエナカ工務店
    579, // 579:桂建設株式会社
    586, // 586:2nd journey
    585, // 585:株式会社SRP
    597, // 597:アップアンドゴー株式会社
    603, // 603:株式会社佐藤塗装
    655, // 655:宮﨑工業
    640, // 640:株式会社SAディール
    666, // 666:株式会社ReBox
    667, // 667:株式会社エンシュウ空調設備
    668, // 668:株式会社そがめ
    672, // 672:株式会社プラシア
    679, // 679:有限会社ユーキ
    673 // 673:株式会社くらしか
  ]
};

//  郵便番号から住所を取得するAPIのベースURL
export const POSTALCODE_API_BASE_URL = 'https://postcode.teraren.com';

// 写真付きの日報を作成した場合、ストレージに自動作成されるフォルダ名
export const DAILY_REPORT_FOLDER_NAME = '日報写真_システム自動作成';

// 箱情報のヘルプアイコンの説明を出し分ける
export const EXT_INFO_SCREEN_TYPE = {
  // 顧客
  CLIENT: 1,
  // 工事
  CONSTRUCT: 2
};

// 社員画面に社員の追加情報入力欄を表示する企業
export const EMPLOYEE_ADD_INFO_TENANT_IDS: { [key: string]: number[] } = {
  local: [1],
  dev: [1],
  stg: [3], // 3:CONOC
  prd: [3, 175] // 3:株式会社CONOC, 175:伏見工業株式会社
};

export const ACCEPTABLE_FILE_TYPES = {
  pdf: ['application/pdf'],
  doc: ['application/msword'],
  docx: [
    'application/vnd.openxmlformats-officedocument.wordprocessingml.document'
  ],
  ppt: ['application/vnd.ms-powerpoint'],
  pptx: [
    'application/vnd.openxmlformats-officedocument.presentationml.presentation'
  ],
  xls: ['application/vnd.ms-excel'],
  xlsx: ['application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'],
  txt: ['text/plain'],
  csv: ['text/csv'],
  ai: ['application/postscript'],
  bmp: ['image/bmp', 'image/x-ms-bmp', 'image/x-bmp'],
  gif: ['image/gif'],
  jpeg: ['image/jpeg'],
  jpg: ['image/jpeg'],
  png: ['image/png'],
  vwx: ['application/vnd.vectorworks'],
  dwg: ['image/vnd.dwg'],
  dxf: ['image/vnd.dxf', 'application/dxf'],
  jwc: ['application/jwc'],
  heic: ['image/heic'],
  heif: ['image/heif'],
  zip: ['application/zip']
};

export const ACCEPTABLE_PICTURE_TYPES = {
  bmp: ['image/bmp', 'image/x-ms-bmp', 'image/x-bmp'],
  gif: ['image/gif'],
  jpeg: ['image/jpeg'],
  jpg: ['image/jpg'],
  png: ['image/png'],
  heic: ['image/heic'],
  heif: ['image/heif']
};

// 社員が選択削除されているか否か
export const EMPLOYEE_STATUS = {
  ACTIVE: 'アクティブ',
  INACTIVE: '非アクティブ'
};

// カスタム見積書を開放する企業一覧
export const CUSTOM_ESTIMATE_ENABLED_TENANTS = {
  local: [1],
  dev: [1],
  stg: [3],
  // 3 CONOC, 290 イテル建設, 623 創電設, 672 株式会社プラシア, 703 株式会社アルモ
  prd: [3, 290, 623, 672, 703]
};

// カスタム見積書で会社印の配置場所を変更する企業一覧
export const CUSTOM_ESTIMATE_STAMP_PLACE = {
  local: [1],
  dev: [1],
  stg: [3],
  // 290 イテル建設
  prd: [290]
};
